module.exports = __webpack_public_path__ + "img/img-4.ce306f88.png";